module.exports = __webpack_public_path__ + "img/footer-bg.23739df5.jpg";